import { StatModule } from "@/core/modules/stat/objects/StatModule";

import DpiStockView from "./views/DpiStockView.vue";

export const dpiStock: StatModule = new StatModule("dpi", "DpiStock", "dpiStat", DpiStockView);
